// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","collapsibleContainer":"ContactUs_collapsibleContainer__WpwUu"};